import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GroupComponent } from './group.component';

@NgModule({
  imports: [CommonModule],
  declarations: [GroupComponent],
  exports: [GroupComponent],
})
export class GroupModule {}
export { GroupComponent } from './group.component';
